<!-- M O B I L E   M E N U   T R I G G E R -->

<div class="mh-head Sticky d-lg-none container-fluid">
    <div class="row d-flex align-items-center">
        <div class="col-2">
            <a href="#mmenu" id="MobMenu" class="fa fa-bars"></a>
            <a href="#main" class="fa fa-close"></a>
        </div>
        <div class="col-8 text-center">
            <a routerLink="/">
                <img class="img-fluid" id="headerLogoMobile" src="assets/img/logos/logoheader.svg"
                    style="height:75px;margin: 10px 0px;">
            </a>
        </div>
    </div>
</div>

<!-- //  M O B I L E   M E N U   T R I G G E R   -->


<!-- M O B I L E   M E N U  -->

<nav id="mmenu">
    <ul id="panel-menu">
        <li>
            <a routerLink="/">Home</a>
        </li>
        <li>
            <a routerLink="/about-us" class="pl-5">About</a>
            <ul>
                <li><a routerLink="/about-us/resource-center">Resource Center</a></li>
                <li><a routerLink="/about-us/insurance-licensing">Insurance Licensing</a></li>
                <li><a routerLink="/about-us/leadership-team">Leadership Team</a></li>

            </ul>
        </li>
        <li>
            <a routerLink="/products" class="pl-5">Products</a>
            <ul>
                <li><a routerLink="/products/homeowners">Homeowners</a></li>
                <li><a routerLink="/products/condo">Condo</a></li>
                <li><a routerLink="/products/renters">Renters</a></li>
                <li><a routerLink="/products/auto">Auto</a></li>
                <li><a routerLink="/products/flood">Flood</a></li>
                <li><a routerLink="/products/earthquake">Earthquake</a></li>
                <li><a routerLink="/products/umbrella">Umbrella</a></li>
                <li><a routerLink="/products/jewelry-and-valuables">Jewelry & Valuables</a></li>
                <li><a routerLink="/products/golf-cart">Golf Cart</a></li>
                <li><a routerLink="/products/motorcycle">Motorcycle</a></li>
                <li><a routerLink="/products/pet-insurance">Pet</a></li>
                <li><a routerLink="/products/travel-insurance">Travel</a></li>
                <li><a routerLink="/products/event">Event</a></li>
                <li><a routerLink="/products/bicycle">Bicycle</a></li>
                <li><a routerLink="/products/small-business">Small Business</a></li>
                <!-- <li><a routerLink="/products/mobile-phone-insurance">Phone</a></li>   -->
            </ul>
        </li>
        <li>
            <a routerLink="/current-customers" class="pl-5">Customers</a>
            <ul>
                <li><a routerLink="/current-customers/claims">Claims</a></li>
                <li><a routerLink="/current-customers/make-a-payment">Make a payment</a></li>
                <li><a routerLink="/current-customers/request-policy-changes">Request Policy Changes</a></li>
                <li><a routerLink="/current-customers/my-policy-documents">My Policy Documents</a></li>
                <li><a routerLink="/current-customers/lender-requests-changes">Lender Requests/Changes</a></li>
                <li><a routerLink="/current-customers/opt-in-for-text-messages">Opt-in For Text Messages</a></li>
            </ul>
        </li>
        <!-- <li>
                <a routerLink="/claims" class="pl-5">Claims</a>
				<ul>
					<li><a routerLink="/claims/report-a-claim">Report a claim</a></li>
					<li><a routerLink="/claims/claim-prevention">Prevent a claim</a></li>
					<li><a routerLink="/claims/minimize-your-loss">Minimize your loss</a></li>
				</ul>
			</li> -->
        <li><a routerLink="/partners" class="pl-5">Partners</a>

            <ul>
                <li><a routerLink="/partners/builders">Builders</a></li>
                <li><a routerLink="/partners/lenders">Lenders</a></li>
                <li><a routerLink="/partners/api">API</a></li>
            </ul>
        </li>
        <li><a routerLink="/news">News</a></li>
        <!-- <li><a routerLink="/contact-us">Contact</a></li> -->
        <li><a routerLink="/get-a-quote">Get A Quote</a></li>
    </ul>
</nav>

<!-- // M O B I L E   M E N U  -->


<!-- M E N U  -->

<section id="header" class="d-none d-lg-block">
    <div class="container-fluid">
        <div class="row">
            <div class="col justify-content-center d-flex align-items-center">
                <a routerLink="/" style="padding-right: 0.8rem;">
                    <img id="headerLogo" src="assets/img/logos/logoheader.svg" alt="Westwood Insurance Logo">
                </a>
                <ul id="mainNav" class="nav d-flex align-items-center">
                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" routerLink="/about-us" id="aboutDropdown"
                            aria-haspopup="true" aria-expanded="false">About</a>
                        <div class="dropdown-menu" aria-labelledby="aboutDropdown">
                            <a class="dropdown-item" routerLink="/about-us/resource-center">Resource Center</a>
                            <a class="dropdown-item" routerLink="/about-us/insurance-licensing">Insurance Licensing</a>
                            <a class="dropdown-item" routerLink="/about-us/leadership-team">Leadership Team</a>
                        </div>
                    </li>
                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" routerLink="/products" id="productsDropdown"
                            aria-haspopup="true" aria-expanded="false">Products</a>
                        <div class="dropdown-menu" aria-labelledby="productsDropdown">
                            <a class="dropdown-item" routerLink="/products/homeowners">Homeowners</a>
                            <a class="dropdown-item" routerLink="/products/renters">Renters</a>
                            <a class="dropdown-item" routerLink="/products/auto">Auto</a>
                            <a class="dropdown-item" routerLink="/products/small-business">Small Business</a>
                            <a class="dropdown-item" routerLink="/products">More Products</a>


                        </div>
                    </li>
                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" routerLink="/current-customers" id="customerDropdown"
                            aria-haspopup="true" aria-expanded="false">Customers</a>
                        <div class="dropdown-menu" aria-labelledby="customerDropdown">
                            <a class="dropdown-item" routerLink="/current-customers/claims">Claims</a>
                            <a class="dropdown-item" routerLink="/current-customers/make-a-payment">Make a payment</a>
                            <a class="dropdown-item" routerLink='/current-customers/request-policy-changes'>Request
                                Policy Changes</a>
                            <a class="dropdown-item" routerLink="/current-customers/my-policy-documents">My Policy
                                Documents</a>
                            <a class="dropdown-item" routerLink="/current-customers/lender-requests-changes">Lender
                                Requests/Changes</a>
                            <a class="dropdown-item" routerLink="/current-customers/opt-in-for-text-messages">Opt-in For
                                Text Messages</a>
                        </div>
                    </li>
                    <!-- <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" routerLink="/claims" id="claimsDropdown"   aria-haspopup="true" aria-expanded="false">Claims</a>
                        <div class="dropdown-menu" aria-labelledby="claimsDropdown">
                            <a class="dropdown-item" routerLink="/claims/report-a-claim">Report a claim</a>
                            <a class="dropdown-item" routerLink="/claims/claim-prevention">Prevent a claim</a>
                            <a class="dropdown-item" routerLink="/claims/minimize-your-loss">Minimize your loss</a>
                        </div>
                    </li> -->
                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" routerLink="/partners" id="partnersDropdown"
                            aria-haspopup="true" aria-expanded="false">PARTNERS</a>
                        <div class="dropdown-menu" aria-labelledby="partnersDropdown">
                            <a class="dropdown-item" routerLink="/partners/builders">BUILDERS</a>
                            <a class="dropdown-item" routerLink="/partners/lenders">LENDERS</a>
                            <a class="dropdown-item" routerLink="/partners/api">API</a>
                        </div>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" routerLink="/news">News</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" routerLink="/contact-us">Contact</a>
                    </li>
                    <li class="nav-item" *ngIf="false">
                        <a class="nav-link telNum" href="tel:18888225396"><i class="fas fa-mobile-alt"></i></a>
                    </li>
                    <li class="nav-item mr-2" *ngIf="false">
                        <a class="nav-link emailUs" href="mailto:Contactus@Westwoodins.com" class=""><i
                                class="fas fa-envelope"></i></a>
                    </li>
                    <li class="nav-item" style="padding-left: 1rem;">
                        <a class="nav-link pl-3 nav-link-cta py-3" routerLink="/get-a-quote">Get A quote</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</section>

<!-- // M E N U  -->